GP.vent.on("init_js:user:cuteornot_full", function(self) {
    var hon_rated_today = 0;
    var hon_man_limit = 50;
    var hon_user_queue = [];
    var processing = false;

    self.hotornot_disable_buttons = function(milsecs) {
        var duration = milsecs || 1500;
        var $hotornot_btns = $('.btn-hotornot-vote');
        $hotornot_btns.addClass('disabled').html('&nbsp;').spin('gp_small');

        setTimeout(function() {
            $hotornot_btns.removeClass('disabled');
            var hon_yes = (GP.sdata.my_user.gender == 'WOMAN') ? js_lang.hon_yes_woman : js_lang.hon_yes_man;
            $('#hotornot_yes').html(hon_yes);
            $('#hotornot_maybe').html(js_lang.hon_maybe);
            $('#hotornot_no').html(js_lang.hon_no);
            $('#rate-multi').html(js_lang.hon_multi_submit);
        }, duration);
    };
    self.update_hotornot_totals = function() {
        // update totals
        $("#total_rated").html(hon_rated_today);

        var goal = 0;
        if (GP.sdata.my_user.gender != 'MAN') {
            goal = 50;
            var hon_goal_msg = js_lang.hon_goal_50;
            if (hon_rated_today >= 50 && hon_rated_today < 200) {
                goal = 200;
                hon_goal_msg = js_lang.hon_goal_200;
            } else if (hon_rated_today >= 200 && hon_rated_today < 400) {
                    goal = 400;
                    hon_goal_msg = js_lang.hon_goal_400;
            } else if (hon_rated_today >= 400 && hon_rated_today < 800) {
                goal = 800;
                hon_goal_msg = js_lang.hon_goal_800;
            } else if (hon_rated_today >= 800) {
                goal = 1000;
                hon_goal_msg = js_lang.hon_goal_max;
            }
            $("#hotornot_goal").html(goal);
            $("#hotornot_msg").html(hon_goal_msg);
        } else {
            goal = hon_man_limit;
            $("#hotornot_goal").html(goal);
        }

        if (hon_rated_today < goal) {
            var vote_percent = (hon_rated_today / goal) * 100;
            $('#votes_main').css("width", vote_percent +"%");
        }
    };
    self.load_next_hotornot = function(rating) {
        processing = true;
        self.hotornot_disable_buttons(1000);

        var hot = [];
        var not = [];
        $('#pics .user_pic').each(function() {
            hon_rated_today++;
            var pic = $(this);
            if (rating == 'cute') {
                hot.push(pic.data('duid'));
            } else if (rating == 'not') {
                not.push(pic.data('duid'));
            } else {
                if (pic.hasClass('selected')) {
                    hot.push(pic.data('duid'));
                } else {
                    not.push(pic.data('duid'));
                }
            }
        });

        // update totals
        self.update_hotornot_totals();

        // send rating
        var rating_data = { add_rating: 1, multiple: 1, hot: hot, not: not };
        $.post('/members/user/hot_or_not/', rating_data)
            .done(function(data) {

                if (data.mutual_match) {
                    var $modal = $('#hon-match-modal');
                    $modal.find('.my-info img').attr('src', GP.sdata.my_user.pic);
                    $modal.find('.my-info span').html(GP.sdata.my_user.username);
                    $modal.find('.match-info a').attr('href', '/members/user/profile/?duid='+data.user.duid);
                    $modal.find('.match-info img').attr('src', data.user.pic);
                    $modal.find('.match-info span').html(data.user.username);
                    $modal.find('.swipe-send-msg').data('duid', data.user.duid);

                    GP.vent.trigger('Modal:open:static', { modal_div_id: '#hon-match-modal' });
                }
                
                if (GP.sdata.my_user.gender == 'MAN' && hon_rated_today >= hon_man_limit) {
                    hon_user_queue = [];
                    self.show_limit_reached();
                } else if (hon_user_queue.length === 0) {
                    self.get_hotornot_users();
                } else {
                    self.show_hotornot_user();
                }
                if (data.stealth_lvl_2_reward) {
                    self.show_goal_50_reached();
                }
                setTimeout(function() {
                    processing = false;
                }, 800);
        });
    };
    self.get_hotornot_users = function(init) {
        $("#action_buttons .loading").show();
        $.get('/members/user/hot_or_not/', {'get_users' : 1, 'user_count' : 8}, function(data) {
            $("#action_buttons .loading").hide();
            if (data.users) {
                hon_user_queue = hon_user_queue.concat(data.users);
                self.show_hotornot_user();
            }
            if (!data.users || data.limit_reached) {
                self.show_limit_reached();
            }

            if (init) {
                hon_rated_today = data.rated_today_count;
                self.update_hotornot_totals();
            }
        });
    };
    self.show_hotornot_user = function() {
        if (hon_user_queue.length) {
            var duids = [];


            var user_count = (GP.sdata.my_user.gender == 'MAN' || MoshPit.get_size() == 'mobile') ? 1 : 8;
            $("#pics .row1, #pics .row2").html('');
            for (var i = 0; i < user_count; i++) {
                var user = hon_user_queue.shift();
                var status= (user.user.status) ? 'ico-online-green ico-online-green-default' : '';
                var $tr =
                    $("<td><div class='user_pic' style='background-image:url("+user.pic_src+");'>"+
                    "<img src='"+cdn_domain+"/images/whos_cute_game/ico_circle_check.png' /></div><a  target='_blank'  href='/members/user/profile/?duid="+user.duid+"'><span class='"+status+"'></span> "+user.user.username+"</a><br /><br /></td>");
                    $tr.find('.user_pic').data({ duid: user.duid, pic_num: user.pic_num});
                if (i < 4) {
                    $('#pics .row1').append($tr);
                } else {
                    $('#pics .row2').append($tr);
                }
            }
        }
    };
    self.show_limit_reached = function() {
        $('.how-to-play-wrap,#votes_wrap,#hotornot_img_box').hide();
        $('#hotornot_msg').html(js_lang.hon_limit_reached);
    };

    self.show_goal_50_reached = function() {
        var $modal = $('#hon-goal-modal');
        $modal.find('#activate_stealth').on('click', function(e){
            var rated_duid = $("#hotornot_form input[name='duid']").val();
            var reward_data = { activate_reward: 1, reward: 'stealth_lvl_2' };
            $.post('/members/user/hot_or_not/', reward_data)
                .done(function(data) {
                    if (typeof data.activate_reward != 'undefined') {
                        var rewards = data.activate_reward;
                        if ($.isPlainObject(rewards)) {
                            for (var reward in rewards) {
                                if (rewards[reward]) {
                                    switch (reward) {
                                        case 'stealth_lvl_2':
                                            $(".nav-stealth").addClass('on').text('On');
                                            $(".nav-stealth-toggle").addClass('on');
                                            break;
                                    }
                                }
                            } 
                        }
                    }
                })
                .always(function() {
                    $modal.modal('hide');
            });
        });
        GP.vent.trigger('Modal:open:static', { modal_div_id: '#hon-goal-modal' });
    };
    
    // init
    self.get_hotornot_users(true);

    $("#pics").on("click", ".user_pic", function() {
        if (MoshPit.get_size() != 'mobile') {
            $(this).toggleClass('selected');
        }
    });

    $("#rate-multi").click(function() {
        if (!processing) {
            self.load_next_hotornot();
        }
    });
    $('#hotornot_yes,#hotornot_maybe').click(function() {
        if (!processing) {
            self.load_next_hotornot('cute');
        }
    });
    $('#hotornot_no').click(function() {
        if (!processing) {
            self.load_next_hotornot('not');
        }
    });


});
